// LICENSE_CODE ZON
/*jslint ts:true, react: true*/
// @ts-ignore
import React, {useContext, useState, useMemo} from 'react';
import cn from 'classnames';

import {use_pathname} from '../../../lib/use_pathname';
import {Settings_context, use_theme} from '../../../settings_ctx';
import date from '/util/date.js';
import {Configure_proxies} from './configure_proxies';
import {use_screen} from '../../../lib/screen_util';
import {Button} from '../../../lib/button';
import styles from './orders.module.less';

// eslint-disable-next-line
export enum Proxy_type {ISP = 'isp', ISPPREM = 'isp_plus',
// eslint-disable-next-line
DDC = 'dedicated_dc', SHARED_ISP = 'shared_isp', SDC = 'shared_dc',
// eslint-disable-next-line
RES = 'smart_resi', EV_ISP = 'events_isp', EV_RES = 'events_resi_tickets',
// eslint-disable-next-line
SNK = 'resi_sneakers',
// eslint-disable-next-line
SCR = 'scraping_browser',
// eslint-disable-next-line
UNKNOWN = 'unknown'};
// eslint-disable-next-line
export type t_proxy_type_map<T> = {[key in Proxy_type]?: T;};
const ORDER_TYPE_NAMES = {
    [Proxy_type.ISP]: 'ISP Proxies',
    [Proxy_type.SHARED_ISP]: 'ISP Proxies',
    [Proxy_type.ISPPREM]: 'ISP Premium Proxies',
    [Proxy_type.DDC]: 'Dedicated Datacenter Proxies',
    [Proxy_type.SDC]: 'Shared Datacenter Proxies',
    [Proxy_type.RES]: 'Rotating Residential Proxies',
    [Proxy_type.EV_ISP]: 'Events & E-commerce Residential Proxies',
    [Proxy_type.EV_RES]: 'Events Tickets Residential Proxies',
    [Proxy_type.SNK]: 'Events Sneakers Residential Proxies',
};

const bw_to_gb = bw=>!bw ? 0 : bw/1000000000;

type Type_picker_props = {
    tab: Proxy_type;
    on_tab_change: (tab: Proxy_type)=>void;
    add_proxies_url: string;
    order_types: Proxy_type[];
};

const Type_picker = ({order_types, add_proxies_url, tab, on_tab_change}
: Type_picker_props)=>{
    const {theme, theme_name} = useContext(Settings_context);

    return <div className={styles.type_container}>
      {order_types.map(type=>
        <div onClick={()=>on_tab_change(type)}
          className={cn(styles.type, type==tab && styles.active)}
          key={type}>
          <p className={cn(theme.p2, type==tab && theme.bold)}>
            {ORDER_TYPE_NAMES[type]}
          </p>
        </div>)}
        <div className={styles.add_proxies}>
          <Button caption="Add Proxies"
            color={theme_name == 'hola2023' ? 'black2023' : 'black'}
            to={add_proxies_url} size="md" />
        </div>
    </div>;
};

interface i_usage_props {
    usage_percent: number;
}
const Usage_display = (props: i_usage_props)=>{
    const {usage_percent} = props;
    const {theme} = useContext(Settings_context);
    return <div className={styles.usage}>
      <p className={cn(theme.p3, theme.reg)}>{usage_percent}%</p>
      <div className={styles.indicator_container}>
        <div className={cn(styles.indicator, styles.total)}/>
        <div className={cn(styles.indicator, styles.used)}
          style={{width: usage_percent+'%'}}/>
      </div>
    </div>;
};

export interface i_row_data {
    id: string;
    token: string;
    create_date: string;
    expiration_date: string;
    is_active: boolean;
    value_columns: string[];
    usage_percent?: number;
    fn: string;
    link: string;
    ips_amount: number;
}

interface i_content_row_props {
    num: number;
    row: i_row_data;
    open_configure: (row: i_row_data)=>void;
}
const Content_row = (props:i_content_row_props)=>{
    const {num, open_configure, row} = props;
    const {token, create_date, expiration_date, usage_percent,
        value_columns, link, is_active} = row;
    const {theme} = useContext(Settings_context);
    const td = x=><td>{x ?? '-'}</td>;
    const tdp = x=>td(<p className={cn(theme.p2, styles.row_text)}>
        {x ?? '-'}</p>);
    return <tr className={cn(styles.row,
      !is_active && styles.disabled, num%2===0 && styles.even,)}>
      {tdp(num+1)}
      {tdp(token)}
      {tdp(create_date)}
      {tdp(expiration_date)}
      {value_columns.map(x=>tdp(x))}
      {!isNaN(usage_percent) &&
        td(<Usage_display usage_percent={usage_percent}/>)}
      {td(<Button caption="+ Renew plan" size="xs" color="white"
        theme="hola2023" to={link} />)}
      {td(<Button caption="Generate >" size="xs" color="white"
        disabled={!is_active} theme="hola2023"
        on_click={()=>open_configure(row)} />)}
    </tr>;
};
interface i_content_table_props {
    custom_headers?: string[];
    row_data?: i_row_data[];
    type: Proxy_type;
    countries?: string[];
    user_ip: string;
    configure_proxies_url: string;
    on_orders_refresh: ()=>void;
    is_show_disabled_slider?: boolean;
}
const Content_table = (props: i_content_table_props)=>{
    const {custom_headers, row_data, ...other} = props;
    const {theme} = useContext(Settings_context);
    const th = x=><th><p className={theme.p3}>{x}</p></th>;
    const with_usage = row_data?.some(x=>!isNaN(x.usage_percent));
    const [modal_row, set_modal_row] = useState<i_row_data | null>(null);
    const on_close=()=>set_modal_row(null);
    return <div className={styles.content_table_container}>
        <table className={styles.content_table}>
          <thead>
            <tr className={styles.row}>
              {th('#')}{th('Token')}{th('Create date')}
              {th('Expiration date')}{custom_headers?.map(x=>th(x))}
              {with_usage && th('Data usage (%)')}
              {th('')}{th('Proxy list')}
            </tr>
          </thead>
          <tbody>
            {row_data?.map((row, i)=><Content_row row={row} num={i} key={i}
              open_configure={r=>set_modal_row(r)}/>)}
          </tbody>
        </table>
        <Configure_proxies
          {...other}
          row={modal_row}
          on_close={on_close}/>
    </div>;
};

export type t_one_proxy = {
    host: string;
    port: string;
    port_selenium?: string;
    login: string;
    password: string;
    country: string;
    socks5: boolean;
}
export type t_generated_proxy = t_one_proxy & {
    ip: string;
    manually_changed?: boolean;

}
export type t_ip = {
    ip: string;
    country: string;
}
export type t_order_users_state = {
    is_new: boolean;
    expired_seen?: boolean;
    hide_used_extra_limits?: boolean;
}
export interface i_extra_limit {
    limit: number;
    start: string; // "2024-04-10T00:00:00.000Z"
}
export interface i_extra_limit_renewal {
    enable: boolean;
    limit: number;
    update_ts: string;
    errors: string[];
}
export interface i_zone_config {
    premium_domains: boolean;
    captcha_solver: boolean;
    passwords: string[];
    allowed_ips: string[];
    blocked_ips: string[];
    allowed_target_hosts: string[];
    blocked_target_hosts: string[];
    special_ports: boolean;
    custom_headers_and_cookies: boolean;
    usage_limit: {
        limit: number;
        limit_kind: 'usd' | 'gb';
        currency: string;
        period: 'day' | 'month';
        exceed_action: 'alert' | 'suspend_zone' | 'suspend_zone_and_alert';
    }
}
export type t_zone_status = 'started' | 'stopped';
export interface i_zone_task {
    _id: string;
    id_cropped: string;
    url: string;
    description: string;
    text: string;
    status: 'running' | 'finalized' | 'failed' | 'awaiting'
        | 'stopped' | 'unknown';
}
export type t_order = {
    _id: string;
    zone: string;
    name?: string;
    client_id: string;
    subscr_id?: string | null;
    subscription_mode?: boolean;
    subscription_cancelled?: boolean;
    cancelled_manually?: boolean;
    plan_id?: string | null;
    plan_duration?: string;
    renew_error?: string[];
    until: string; // "2024-07-10T00:00:00.000Z"
    start: string; // "2024-04-10T00:00:00.000Z"
    blocking_date?: string;
    blocking_in_hours?: number;
    limit: number;
    type: Proxy_type;
    usage_info?: {used: number;};
    free_zone?: boolean;
    ips_amount?: number;
    enable_additional_usage_charges?: boolean;
    ips_whitelist?: string[];
    unit?: 'ip' | 'gb';
    generated_proxies?: t_generated_proxy[];
    subscription_until?: string;
    user_state?: t_order_users_state,
    prev_usage?: {
        used: number;
        limit: number;
    };
    plan_limit?: number;
    additional_limit?: number;
    next_zone_id?: string;
    group_id?: string;
    is_legacy?: boolean;
    plan_price?: number;
    expired_recently?: boolean;
    extra_limits?: i_extra_limit[];
    extra_limit_renewal?: i_extra_limit_renewal;
    allowed_bw_renewal?: boolean;
    auth_type?: 'ip' | 'user';
    disabled?: {
        ts: string;
        reason: string;
        source: string;
    };
    rotated_by_user_ts?: string;
    status?: t_zone_status;
    config?: i_zone_config;
    tasks?: i_zone_task[];
};

export type t_orders = {
    dedicated_dc: t_order[];
    isp: t_order[];
    shared_dc: t_order[];
    shared_isp: t_order[];
    isp_plus: t_order[];
    smart_resi: t_order[];
};

export type t_zone_group = {
    _id: string;
    subscr_id?: string | null;
    subscription_cancelled?: boolean;
    plan_id?: string | null;
    name?: string;
    type: string;
    start: string;
    until: string;
    limit: number;
    usage_info?: {used: number;};
    unit?: 'ip' | 'gb';
    subscription_until?: string;
    user_state?: t_order_users_state;
    enable_additional_usage_charges: boolean;
    zones: t_order[];
    next_group_id?: string;
    allowed_bw_renewal?: boolean;
    free_group?: boolean;
    prev_usage?: {
        used: number;
        limit: number;
    };
    extra_limits?: i_extra_limit[];
    extra_limit_renewal?: i_extra_limit_renewal;
}

type t_cart_item = {
    plan: {
        id: Proxy_type
    },
    quantity: string; // "25"
    country: string; // "us" | "il"
};

export type t_payment = {
    ccard_country: string;
    ccard_exp_month: number;
    name: string;
    ccard_exp_year: number;
    ccard_lbl: string;
    ccard_last4: string;
    ccard_type: string;
    cart?: t_cart_item[];
};

export type t_payment_method = {
    id: string;
    card_country: string;
    card_exp_lbl: string;
    card_last4: string;
    card_lbl: string;
    card_type: string;
    error?: string
};

export type t_user_info = {
    email: string;
    first_name: string;
    last_name: string;
    ip: string;
};

export type t_account = {
    user_info: t_user_info;
    last_payment?: t_payment;
    payment_methods?: t_payment_method[];
};

interface i_orders_tab_props {
    order_types: Proxy_type[];
    add_proxies_url?: string;
    renew_plan_url?: (product: string, amount:string)=>string;
    configure_proxies_url?: string;
    is_show_disabled_slider?: boolean;
    orders: t_orders;
    on_orders_refresh: ()=>void;
    countries?: t_proxy_type_map<string[]>;
    account: t_account;
}

export const Orders_tab = (props: i_orders_tab_props)=>{
    const {params, set} = use_pathname();
    const {orders, countries, account, on_orders_refresh,
    add_proxies_url = '/pro/products',
    configure_proxies_url ='/pro_api/proxies/configure',
    is_show_disabled_slider,
    renew_plan_url = (product, amount)=>
        `/pro/checkout?product=${product}&amount=${amount}`,
    order_types} = props;
    const user_ip = account?.user_info?.ip;
    const active_tab = (params.sub
        || account.last_payment?.cart?.[0]?.plan?.id
        || order_types[0]) as Proxy_type;
    const on_set_active_tab = (tab: Proxy_type)=>set({sub: tab});
    const date_fmt = (x: string): string=>x && date.strftime('%b %d, %Y', x);
    const base_map = (x: t_order)=>{
        const usage_percent = calc_used(x);
        return {
            id: x._id,
            token: x.client_id,
            create_date: date_fmt(x.start),
            expiration_date: date_fmt(x.until),
            usage_percent,
            unit: x.unit,
            ips_amount: x.ips_amount,
            is_active: usage_percent < 100 && new Date(x.until) > new Date(),
        };
    };
    const calc_used = (x: t_order)=>{
        return 0 && Math.min(Math.floor(0/x.limit*100), 100);
    };
    const type_data: t_proxy_type_map<i_row_data[]> = useMemo(()=>{
        if (!orders)
            return {};
        return {
            isp: orders?.isp?.map(x=>{
                const gb = bw_to_gb(x.limit);
                return Object.assign(base_map(x),
                    {value_columns: [gb.toFixed(2)], fn: `${gb}G`,
                    link: renew_plan_url('isp', gb.toFixed(0))});
            }),
            isp_plus: orders?.isp_plus?.map(x=>{
                const gb = bw_to_gb(x.limit);
                return Object.assign(base_map(x),
                    {value_columns: [gb.toFixed(2)], fn: `${gb}G`,
                    link: renew_plan_url('isp_plus', gb.toFixed(0))});
            }),
            shared_dc: orders?.shared_dc?.map(x=>{
                const gb = bw_to_gb(x.limit);
                return Object.assign(base_map(x),
                    {value_columns: [gb.toFixed(2)], fn: `${gb}G`,
                        link: renew_plan_url('shared_dc', gb.toFixed(0))});
            }),
            dedicated_dc: orders?.dedicated_dc?.map(x=>{
                const quantity = x.ips_amount ?? 0;
                return Object.assign(base_map(x),
                    {value_columns: [`${quantity}`], fn: `${quantity}`,
                link: renew_plan_url('dedicated_dc', quantity.toFixed(0))});
            }),
            smart_resi: orders?.smart_resi?.map(x=>{
                const gb = bw_to_gb(x.limit);
                return Object.assign(base_map(x),
                    {value_columns: [gb.toFixed(2)], fn: `${gb}G`,
                    link: renew_plan_url('smart_resi', gb.toFixed(0))});
            }),
        };
    }, [orders]);

    const {width} = use_screen();
    const is_mobile = width < 1200;
    const {theme, theme_name} = use_theme();
    const render_type = (t: Proxy_type)=>{
        if (t==null)
            return null;
        const custom_headers = {
            isp: ['Balance (GB)'],
            isp_plus: ['Balance (GB)'],
            shared_dc: ['Balance (GB)'],
            dedicated_dc: ['Qty'],
        }[t];

        return <Content_table row_data={type_data[t]}
          is_show_disabled_slider={is_show_disabled_slider}
          countries={t!=Proxy_type.DDC && Array.isArray(countries[t])
            ? countries[t]: null}
          custom_headers={custom_headers}
          configure_proxies_url={configure_proxies_url}
          on_orders_refresh={on_orders_refresh}
          type={t} user_ip={user_ip}/>;
    };

    if (is_mobile)
    {
        return <>{order_types
          .filter(t=>type_data[t]?.length > 0)
          .map(t=>
            <div key={t} className={styles.orders_tab_wrapper}>
              <div className={styles.orders_tab_scroll}>
                <p className={cn(theme.p1, theme.med, styles.mob_header)}>
                  {ORDER_TYPE_NAMES[t]}
                </p>
                <div className={styles.orders_tab}>
                  {render_type(t)}
                </div>
              </div>
            </div>)}
          <Button caption="Add Proxies"
            to={add_proxies_url}
            cls={styles.mob_add_proxies}
            color={theme_name == 'hola2023' ? 'black2023' : 'black'}
            size="md" />
        </>;
    }

    return <div className={styles.orders_tab}>
        <Type_picker
          tab={active_tab} on_tab_change={on_set_active_tab}
          order_types={order_types} add_proxies_url={add_proxies_url} />
        {render_type(active_tab)}
    </div>;
};
